import { log_error_js } from './logging.js';
import { currentTimestamp } from "../helpers/time.js";

// --- Global JS error reporting ---
let _reporting_error = false;
let _error_count = 0;
const MAX_JS_ERRORS = 10;

function report_js_error(payload) {
    if (_reporting_error || _error_count >= MAX_JS_ERRORS) return;
    _error_count++;
    _reporting_error = true;
    log_error_js(payload);
    _reporting_error = false;
}

window.addEventListener('error', (event) => {
    report_js_error({
        type: 'error',
        message: event.message || 'Unknown error',
        source: event.filename || null,
        lineno: event.lineno || null,
        colno: event.colno || null,
        stack: event.error?.stack || null,
        url: window.location.href,
        timestamp: currentTimestamp(),
    });
});

window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    report_js_error({
        type: 'unhandledrejection',
        message: reason instanceof Error ? reason.message : String(reason ?? 'Unhandled rejection'),
        stack: reason instanceof Error ? reason.stack : null,
        url: window.location.href,
        timestamp: currentTimestamp(),
    });
});

const $year = document.getElementById('CopyrightYear');
if ($year) $year.innerHTML = new Date().getFullYear() + '';

document.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
        document.body.classList.add("scrolled");
    } else {
        document.body.classList.remove("scrolled");
    }
});
